export const onboardingStages = {
  DOCS_UPLOADED: 'DocsUploaded',
  PAN_VERIFIED: 'PANVerified',
  PAN_NOT_VERIFIED: 'PANnotVerified',
  DOCS_NOT_UPLOADED: 'DocsNotUploaded',
  CAN_FORM_COMPLETED: 'CanFormCompleted',
  ONBOARDING_COMPLETE: 'OnboardingComplete'
}

export const onboardingForms = {
  KYC_CHECK: 'KYC_CHECK',
  KYC_READY: 'KYC_READY',
  UPDATE_DOCS: 'UPDATE_DOCS',
  KYC_INCOMPLETE: 'KYC_INCOMPLETE',
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  RESIDENCE_DETAILS: 'RESIDENCE_DETAILS',
  MISCELLENOUS: 'MISCELLENOUS',
  SETUP_COMPLETED: 'SETUP_COMPLETED'
}

export const kycVerificationStatus = {
  KYC_INCOMPLETE: "New kyc",
  KYC_COMPLETE: "Verified Kyc"
}